<script lang="ts">
import type { CompositePrimaryKey } from '#layers/data-model';

export interface ListingSelectionActionsProps {
	selection: CompositePrimaryKey[];
	visible?: boolean;
	canBulkDelete?: boolean;
	deleteLabel?: string;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import { ButtonRemove } from '#layers/ui';

const props = withDefaults(defineProps<ListingSelectionActionsProps>(), {
	visible: undefined,
});

defineEmits<{
	clear: [];
	deleteItems: [];
}>();

const appConfig = useAppConfig();

const isVisible = computed(() => (props.visible ?? true) && props.selection.length > 0);
</script>

<template>
	<Transition
		enter-active-class="transition-opacity ease-out duration-75"
		enter-from-class="opacity-0"
		enter-to-class="opacity-100"
		leave-active-class="transition-opacity ease-in duration-75"
		leave-from-class="opacity-100"
		leave-to-class="opacity-0"
	>
		<div v-if="isVisible" class="absolute inset-0 bottom-px flex items-center bg-default">
			<div class="flex flex-1 items-center justify-between px-page">
				<div class="flex items-center gap-2">
					<DTooltip :text="$t('listing.selection.clear')">
						<DButton class="-ms-1.5" color="neutral" variant="ghost" size="sm" :icon="appConfig.ui.icons.close" @click="$emit('clear')" />
					</DTooltip>
					<span class="text-sm font-medium">
						{{ $t('common.selection_count', { n: selection.length }) }}
					</span>
				</div>
				<div class="flex items-center gap-2">
					<ButtonRemove
						v-if="canBulkDelete"
						variant="outline"
						:label="deleteLabel ?? $t('common.delete')"
						@click="$emit('deleteItems')"
					/>
				</div>
			</div>
		</div>
	</Transition>
</template>
